import { z } from 'zod';
import { MAX_BREW_COUNT } from '../data/alchemy.js';
/**
 * The alchemist (ADR 0026). The client names the potion and how many; the
 * server knows the recipe of the biome the alchemist stands in, takes the
 * materials and the gold, and brews.
 */
export const BrewPotionMessageSchema = z.object({
    potion: z.string().min(1).max(64),
    count: z.number().int().min(1).max(MAX_BREW_COUNT),
});
/** To the owner alone, after the brew; the new inventory, gold included, follows. */
export const BrewResultSchema = z.object({
    potion: z.string().min(1),
    count: z.number().int().min(1),
    gold: z.number().int().min(0),
});
export const BREW_REFUSALS = [
    'invalid',
    'unknown-recipe',
    'missing-materials',
    'missing-gold',
    'bag-full',
    'too-far',
];
export const BrewRejectedSchema = z.object({ reason: z.enum(BREW_REFUSALS) });
//# sourceMappingURL=alchemy.js.map